<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'ユーザー情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'ユーザー情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addUser()" [disabled]="!userFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="userFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="20px">
        <div class="dialog-left" fxLayout="column" fxFlex="50%" fxLayoutGap="20px">

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">ID</mat-label>
            <input matInput *ngIf="!isAdded" placeholder="ID" id="userId" formControlName="userId" readonly>
            <input matInput *ngIf="!!isAdded" placeholder="ID" id="userId" formControlName="userId">
            <mat-error *ngIf="userIdControl.invalid">{{ getErrorMessageToUserId() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="userName" formControlName="userName">
            <mat-error *ngIf="userNameControl.invalid">{{ getErrorMessageToUserName() }}</mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="loginUserType==USER_TYPE_ADMIN" fxFlex="100%">
            <mat-label floatLabel="always">{{'管理者区分' | translate}}</mat-label>
            <mat-select placeholder="{{'管理者区分' | translate}}" id="userType" formControlName="userType" (selectionChange)="selectUserType($event)">
              <mat-option *ngFor="let userType of userTypes" [value]="userType">{{ userType | typeOfUser }}</mat-option>
            </mat-select>
            <mat-error *ngIf="userTypeControl.invalid">{{ getErrorMessageToUserType() }}</mat-error>
          </mat-form-field>

          <div *ngIf="userTypeControl.value==USER_TYPE_USER" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
            <mat-checkbox formControlName="isEdit" color="primary">{{'展示物更新を許可する' | translate}}</mat-checkbox>
          </div>

          <div class="project-table" *ngIf="userTypeControl.value !== USER_TYPE_ADMIN">
            <p *ngIf="userTypeControl.value !== USER_TYPE_USER">{{'参照プロジェクト追加' | translate}}</p>
            <p *ngIf="userTypeControl.value === USER_TYPE_USER">{{'展示物を選択してください' | translate}}</p>
            <table>
              <thead>
                <tr>
                  <th>
                    <mat-checkbox *ngIf="userTypeControl.value !== USER_TYPE_ADMIN" color="primary"
                      (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                    <span *ngIf="userTypeControl.value !== USER_TYPE_ADMIN"> {{'全' | translate}} </span>
                  </th>
                  <th>ID</th>
                  <th>{{'プロジェクト' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let project of projects; let i = index">
                  <td><mat-checkbox *ngIf="userTypeControl.value !== USER_TYPE_ADMIN" color="primary"
                      (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(project) : null"
                      [checked]="selection.isSelected(project)" [aria-label]="checkboxLabel(project)">
                    </mat-checkbox></td>
                  <td>{{ project.project_id }}</td>
                  <td>{{ project.project_name }}</td>
                  <table *ngIf="userTypeControl.value === USER_TYPE_USER && projectExhibits[project.project_id]">
                    <thead>
                      <tr>
                        <th width="10%">
                          <mat-checkbox color="primary" (change)="$event ? exhibitMasterToggle(project) : null"
                            (change)="checkExhibit(project, null)"
                            [checked]="exhibitSelections[project.project_id].hasValue() && exhibitIsAllSelected(project)"
                            [indeterminate]="exhibitSelections[project.project_id].hasValue() && !exhibitIsAllSelected(project)"
                            [aria-label]="exhibitCheckboxLabel(project)">
                          </mat-checkbox>
                          <span> {{'全' | translate}} </span>
                        </th>
                        <th width="15%">{{'展示ID' | translate}}</th>
                        <th width="75%">{{'展示' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let exhibit of projectExhibits[project.project_id]">
                        <td><mat-checkbox color="primary" (click)="$event.stopPropagation()"
                            (change)="$event ? exhibitSelections[project.project_id].toggle(exhibit) : null"
                            (change)="checkExhibit(project, exhibit)"
                            [checked]="exhibitSelections[project.project_id].isSelected(exhibit)"
                            [aria-label]="exhibitCheckboxLabel(project, exhibit)">
                          </mat-checkbox></td>
                        <td>{{ exhibit.exhibit_id }}</td>
                        <td>{{ exhibit.exhibit_names[0].name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="dialog-body-right" fxLayout="column" fxFlex="50%" fxLayoutGap="20px" [style.height.px]="280">
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="userDesc" formControlName="userDesc" rows="11"></textarea>
            <mat-error *ngIf="userDescControl.invalid">{{ getErrorMessageToUserDesc() }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>


</div>